import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './PeriodePphUnifikasi.service'
import EntitasService from '../../master/Entitas/Entitas.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import { inject, observer } from 'mobx-react'
import Utils from '../../../libs/custom/Utils'

var _baseId = "mod-table-periode-unifikasi"

const PeriodePphUnifikasiTable = ({
  className       = '',
  showCommandbar  = true,
  history,
  sipStore,
  navigationStore,
  modalStore
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})
  const [entitasList, setEntitasList] = useState([])
  const [entitasMap, setEntitasMap] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title='Periode PPh Unifikasi'
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Status Approval',
          searchable: true,
          key: 'statusApproval',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.statusApproval)
        },
        {
          label: 'Npwp',
          searchable: true,
          key: 'npwp',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.entitas.npwp)
        },
        {
          label: 'Nama',
          searchable: true,
          key: 'nama',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.entitas.nama)
        },
        {
          label: 'Tahun Fiskal',
          searchable: true,
          key: 'tahunFiskal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tahunPajak)
        },
        {
          label: 'Masa Fiskal',
          searchable: true,
          key: 'masaFiskal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.masaPajak)
        },
        {
          label: 'DPP',
          searchable: true,
          key: 'dpp',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.dpp))
        },
        {
          label: 'PPh',
          searchable: true,
          key: 'pph',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.pph))
        },
        {
          label: 'Status Kirim',
          searchable: true,
          key: 'statusKirim',
          type: TableWrapper.dataTypes.STRING,
          render: item => item.statusKirim
        },
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/periode-unifikasi/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Buat Menu PPh Unifikasi', 'mdi mdi-book-open', (item) => {
          localStorage.setItem("sip-unifikasi-pph", JSON.stringify(item));
          history.push(`/pph-unifikasi-menu/index`);
        }, true),
        // new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/periode-unifikasi/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        if(!query) query = {}
        if(sipStore.companyId) {
          query['perusahaanId.equals'] = sipStore.companyId
        }
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default inject('sipStore', 'navigationStore', 'modalStore')(observer(PeriodePphUnifikasiTable))
